import React, { useState } from "react";
import { ShieldCheck, Info } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export function DisclaimerBar() {
  return (
    <div className="flex items-start gap-3 max-w-3xl mx-auto text-neutral-500">
      <ShieldCheck size={22} className="text-[#73bf44] shrink-0 mt-0.5" weight="duotone" />
      <p className="text-xs leading-relaxed">
        Nick provides AI-generated technical information based on available OTM documentation and caravan
        specifications. Always follow manufacturer instructions and use a qualified technician for electrical,
        gas or safety-critical work.{" "}
        <DisclaimerDialog>
          <button className="text-neutral-300 underline underline-offset-2 hover:text-[#73bf44] transition-colors" data-testid="disclaimer-learn-more">
            Learn more
          </button>
        </DisclaimerDialog>
      </p>
    </div>
  );
}

export function DisclaimerDialog({ children }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="bg-[#0F0F0F] border-neutral-800 text-neutral-200 max-w-lg" data-testid="disclaimer-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 text-white">
            <ShieldCheck size={22} className="text-[#73bf44]" weight="duotone" /> AI Technical Assistance
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-neutral-400 leading-relaxed">
          <p>
            Nick is an AI technical assistant for On The Move Caravans. Responses are generated from OTM
            documentation, caravan specifications and approved technical knowledge, combined with AI reasoning.
          </p>
          <p>
            While we work hard to keep this information accurate, AI can make mistakes. Information provided
            here does not replace professional advice.
          </p>
          <ul className="list-disc pl-5 space-y-1.5 marker:text-[#73bf44]">
            <li>Always follow the manufacturer's instructions supplied with your appliances and systems.</li>
            <li>Electrical, gas, brake and structural work must be carried out by a suitably qualified technician.</li>
            <li>If you smell gas, see smoke, or suspect an electrical fault, stop and seek professional help immediately.</li>
            <li>For urgent or safety-related issues, contact your dealer or On The Move Caravans directly.</li>
          </ul>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function InfoButton() {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid="info-button"
          className="w-9 h-9 rounded-full border border-neutral-700 flex items-center justify-center text-neutral-400 hover:text-white hover:border-neutral-500 transition-colors"
        >
          <Info size={18} />
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#0F0F0F] border-neutral-800 text-neutral-200 max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 text-white">
            <ShieldCheck size={22} className="text-[#73bf44]" weight="duotone" /> AI Technical Assistance
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-neutral-400 leading-relaxed">
          <p>Nick provides technical information based on available OTM documentation and caravan specifications.</p>
          <ul className="list-disc pl-5 space-y-1.5 marker:text-[#73bf44]">
            <li>Always follow manufacturer instructions.</li>
            <li>Use a qualified technician for electrical or safety-critical work.</li>
            <li>For urgent issues, contact your dealer or On The Move Caravans directly.</li>
          </ul>
        </div>
      </DialogContent>
    </Dialog>
  );
}
